import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from "react";
import TextField from "../TextField";
import DebounceChange from "./DebounceChange";

var DebouncedTextField = function DebouncedTextField(props) {
  var time = props.time,
      resetValue = props.resetValue,
      originalValue = props.value,
      onChange = props.onChange,
      textFieldProps = _objectWithoutProperties(props, ["time", "resetValue", "value", "onChange"]);

  return React.createElement(DebounceChange, {
    resetValue: resetValue,
    debounce: onChange,
    time: time,
    value: originalValue
  }, function (_ref) {
    var change = _ref.change,
        value = _ref.value;
    return React.createElement(TextField, _extends({}, textFieldProps, {
      value: value,
      onChange: change
    }));
  });
};

DebouncedTextField.defaultProps = {
  time: 250
};
export default DebouncedTextField;